import { logger } from '../../lib/logging'
import storage from '../../lib/localstorage.jsx'
import { Authentication } from './authentication'
import { InvalidCredentials } from './invalidCredentials'
import { AccountLocked } from './accountLocked'
import { SessionNotAuthenticated } from './sessionNotAuthenticated'
import { UNAUTHORIZED } from 'http-status-codes'

export class LocalAuthentication extends Authentication {
  init () {
    logger.debug('Authenticating locally...')
    return this.app.feathers
      .reAuthenticate()
      .then(({ user }) => {
        // Upon login, we check if there is an active team in the localstorage.
        const teamId = this.app.teamContext.getActiveTeamIdFromStorage()
        logger.debug('Active team id in storage:', teamId)
        return this.afterLogin(user, teamId).then((data) => {
          logger.debug('Authenticated locally', { user })
          return data
        })
      }).catch(error => {
        if (error.name === 'NotAuthenticated') {
          throw new SessionNotAuthenticated()
        } else {
          throw error
        }
      })
  }

  async login ({ email, password, isSignupFlow }) {
    logger.debug('Logging in', { email })

    try {
      const { user } = await this.app.feathers.authenticate({
        email: email,
        password,
        strategy: 'local'
      })

      logger.debug('Logged in successfully', { user })
      return this.afterLogin(user, null, isSignupFlow)
    } catch (error) {
      if (error.message === 'Invalid login' || error.code === UNAUTHORIZED) {
        throw new InvalidCredentials()
      }
      if (error.message === 'Account locked for 30 minutes') {
        throw new AccountLocked()
      }
      throw error
    }
  }

  logout () {
    logger.debug('Logging out')
    this.app.feathers.logout()
    storage.clear()

    // If we are currently on a page that requires authorization we redirect to the login page.
    if (!this.isGuestPage(window.location.pathname)) {
      logger.debug('User is not on a guest page, so redirecting to /login.')
      return this.app.redirect('/login')
    }
  }

  refresh () {
    return this.app.feathers.reAuthenticate()
  }
}
